import { useMutation } from '@apollo/client';
import { Mutations } from 'apollo';
import useAuthContext from 'hooks/useAuthContext';

const useCreateW4 = () => {
  const context = useAuthContext();
  const [
    mutate,
    { loading, data },
  ] = useMutation(Mutations.createW4DocusignerDocument, { context });
  const createW4 = (stateId, country = 'US') =>
    mutate({ variables: { stateId, country } }).then(
      response => response.data.createW4DocusignerDocument,
    );
  const newW4 = data && data.createW4DocusignerDocument;
  return [createW4, { loading, data: newW4 }];
};

export default useCreateW4;
